import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { trackPageView, initEngagementTracking } from "@/lib/track";

// Fires a first-party page_view on every public route change. Admin routes are excluded.
export default function Tracker() {
  const { pathname } = useLocation();
  useEffect(() => { initEngagementTracking(); }, []);
  useEffect(() => {
    if (pathname.startsWith("/admin")) return;
    const t = setTimeout(() => trackPageView(pathname, document.title), 60);
    return () => clearTimeout(t);
  }, [pathname]);
  return null;
}
